<div class="wrapper">
  @if (!isEditState()) {
    <div
      class="default-state"
      [class.readonly]="!isUserCanEdit()"
      (click)="handeEditValue()"
    >
      <div>
        {{ formatNumberValue(startValue()) }}
      </div>
    </div>
  } @else {
    <div class="edit-state">
      <input
        type="number"
        [(ngModel)]="startValue"
      >
      <button
        class="close"
        (click)="handleResetValue()"
      >
        <i class="close-icon"></i>
      </button>
      <button
        class="save"
        (click)="handleSaveValue()"
      >
        <i class="save-icon"></i>
      </button>
    </div>
  }
</div>
